"use client";

import { usePath } from "@packages/framework";
import {
  useRedirectToAuth,
  useRequestCampaignUsers,
  useSession,
} from "@packages/sdk";
import type { MouseEventHandler } from "react";
import { forwardRef } from "react";

import type { HallowElement } from "../../../../../types/hallowElement.types";
import type { HallowElementProps } from "../../../../../types/hallowElementProps.types";

const Element: HallowElement = "button";

export type CampaignJoinLeaveButtonProps = HallowElementProps<
  typeof Element
> & {
  campaignId: number;
  campaignName?: string;
  joined: boolean;
};

export const CampaignJoinLeaveButton = forwardRef<
  any,
  CampaignJoinLeaveButtonProps
>(({ campaignId, campaignName, children, joined, onClick, ...props }, ref) => {
  const path = usePath();
  const redirectToAuth = useRedirectToAuth();

  const { mutationDelete, mutationPost } = useRequestCampaignUsers({
    id: campaignId,
  });
  const { status } = useSession();

  const handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    if (status === "authenticated") {
      if (onClick) onClick(event);

      if (joined) return mutationDelete.mutateAsync();
      else {
        mutationPost.mutate();
        if (path !== `/campaigns/${campaignId}`)
          window.location.href = `/campaigns/${campaignId}`;
        return;
      }
    }

    if (onClick) onClick(event);
    return redirectToAuth({
      queries: campaignName
        ? { campaign_name: campaignName, reason: "campaign" }
        : { reason: "campaign" },
    });
  };

  return (
    <button onClick={handleClick} ref={ref} {...props}>
      {children}
    </button>
  );
});

CampaignJoinLeaveButton.displayName = "CampaignJoinLeaveButton";
